import React from "react";
import { Collapse, Button, Card } from "antd";
import {
  HelpCircle,
  CreditCard,
  Image,
  ShieldCheck,
  Clock,
  MessageCircle,
  Zap,
  Gift,
} from "lucide-react";
import WebsiteHeader from "../Components/WebsiteHeader";
import WebsiteFooter from "../Components/WebsiteFooter";

export default function Faq() {

     const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };
  const items = [
    {
      key: "1",
      label: "What is ShipLess AI?",
      children:
        "ShipLess AI helps Meesho sellers optimize product images to reduce shipping charges and increase profits.",
    },
    {
      key: "2",
      label: "How does ShipLess AI work?",
      children:
        "Upload your product image, our AI generates multiple optimized versions and finds the one with the lowest shipping charge.",
    },
    {
      key: "3",
      label: "How many credits does one optimization cost?",
      children:
        "Currently 1 optimization costs 10 credits.",
    },
    {
      key: "4",
      label: "What is the credit value?",
      children:
        "1 Credit = ₹1. You only pay for the optimizations you use.",
    },
    {
      key: "5",
      label: "Do credits expire?",
      children:
        "No. Your credits never expire and can be used anytime.",
    },
    {
      key: "6",
      label: "Can I optimize unlimited images?",
      children:
        "Yes, as long as you have credits available in your wallet.",
    },
    {
      key: "7",
      label: "Will image quality be reduced?",
      children:
        "Our AI keeps image quality high while reducing file size and dimensions.",
    },
    {
      key: "8",
      label: "Is my data safe?",
      children:
        "Yes. Your images and account data are completely secure. We never share your images.",
    },
    {
      key: "9",
      label: "How fast is optimization?",
      children:
        "Most optimizations complete within a few seconds.",
    },
    {
      key: "10",
      label: "Do you offer refunds?",
      children:
        "Please contact support and no refund",
    },
  ];

  return (
    <div className="bg-[#fbfaff] min-h-screen">
      <WebsiteHeader />

      <main className="max-w-[1200px] mx-auto px-4 py-12">
        {/* Hero */}
        <section className="text-center py-8">
          <div className="inline-flex bg-purple-100 text-purple-700 px-4 py-2 rounded-full font-bold text-sm">
            ❓ Frequently Asked Questions
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold mt-5">
            Got Questions?
            <br />
            <span className="text-purple-600">
              We Have Answers
            </span>
          </h1>

          <p className="text-slate-600 text-lg mt-5 max-w-2xl mx-auto">
            Everything you need to know about ShipLess AI,
            credits, pricing and image optimization.
          </p>
        </section>

        {/* Quick Info */}
        <section className="grid grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          <QuickCard
            icon={<CreditCard />}
            title="1 Credit = ₹1"
          />

          <QuickCard
            icon={<Image />}
            title="10 Credits / Optimization"
          />

          <QuickCard
            icon={<ShieldCheck />}
            title="100% Secure"
          />

          <QuickCard
            icon={<Clock />}
            title="Instant Results"
          />
        </section>

        {/* FAQs */}
        <section className="grid grid-cols-1 lg:grid-cols-[1fr_350px] gap-8 mt-10">
          <Card className="rounded-3xl shadow-sm">
            <h2 className="text-3xl font-extrabold mb-6">
              Frequently Asked Questions
            </h2>

            <Collapse
              accordion
              size="large"
              items={items}
            />
          </Card>

          <div className="space-y-6">
            {/* <Card className="rounded-3xl shadow-sm">
              <div className="text-center">
                <div className="w-20 h-20 bg-purple-100 text-purple-600 rounded-full mx-auto flex items-center justify-center">
                  <MessageCircle size={38} />
                </div>

                <h3 className="text-2xl font-extrabold mt-5">
                  Need More Help?
                </h3>

                <p className="text-slate-600">
                  Our support team is here to help you.
                </p>

                <Button
                onClick={() => handleRedirect('https://wa.me/918602490161?text=Hi Shipless Tool')}
                  type="primary"
                  size="large"
                  className="bg-purple-600 w-full h-12 mt-4"
                >
                  Contact Support
                </Button>
              </div>
            </Card> */}

            <Card className="rounded-3xl shadow-sm bg-purple-50">
              <div className="flex gap-4">
                <div className="w-14 h-14 rounded-xl bg-white text-purple-600 flex items-center justify-center">
                  <Zap />
                </div>

                <div>
                  <h3 className="font-extrabold">
                    Optimization Tip
                  </h3>

                  <p className="text-slate-600">
                    Use a clear front-side product image
                    for the best shipping optimization results.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </section>

        {/* CTA */}
        <section className="mt-10 bg-gradient-to-r from-purple-700 to-purple-600 rounded-3xl p-8 text-white">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="flex items-center gap-5">
              <div className="text-6xl">
                🎁
              </div>

              <div>
                <h2 className="text-3xl font-extrabold">
                  Ready to Save on Shipping?
                </h2>

                <p className="mt-2">
                  Join ShipLess AI and get 30 free credits.
                </p>
              </div>
            </div>

            <Button
            onClick={() => handleRedirect('https://dashboard.shipless.in/')}
              size="large"
              className="h-14 px-10 font-bold"
            >
              <Gift size={18} />
              Get 30 Free Credits
            </Button>
          </div>
        </section>
      </main>

      <WebsiteFooter />
    </div>
  );
}

function QuickCard({ icon, title }) {
  return (
    <Card className="rounded-2xl shadow-sm">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center mx-auto">
          {icon}
        </div>

        <h3 className="font-extrabold mt-4">
          {title}
        </h3>
      </div>
    </Card>
  );
}